import React from "react";
//import { useState } from "react";
import screenshot from "../assets/bookmarklet2.jpg";
import useCopyToClipboard from "../hooks/useCopyToClipboard";

export default function URLDataOverlay() {
  //  return [copied, copy];
  // Call the hook
  const [copied, , copy] = useCopyToClipboard();

  //const [copied, setCopied] = useState(false);

  //   const handleCopyToClipboard = () => {
  //     navigator.clipboard.writeText(bookmarkletCode);
  //     //alert("Copied to clipboard!");
  //     setCopied(true);
  //     console.log(copied);
  //     setTimeout(() => {
  //       setCopied(false);
  //       console.log(copied);
  //     }, 5000);
  //   };

  const bookmarkletCode = `javascript:!function(){const e=document.querySelectorAll("a");let t=document.querySelectorAll(".link-overlay");if(t.length>0)return void t.forEach((e=>e.remove()));let l=9999,o=[];e.forEach((e=>{e.style.position="relative";let t=document.createElement("div"),s=[];s=[...e.attributes].filter((e=>"target"!==e.name&&"rel"!==e.name&&"class"!==e.name&&"href"!==e.name&&"title"!==e.name&&"style"!==e.name&&"text"!==e.name)).map((e=>({key:e.name,value:e.value})));let r=[],a=new URLSearchParams(e.search);for(const[e,t]of a.entries())r.push({key:e,value:t});let n=e.text||e.querySelector("img")?.alt||"";o={title:e.title,href:e.href,text:e.text,attrs:s,params:r};let i="";i+='<ul style="margin: 0; padding: 0; list-style: none;">',i+='<li style="padding-bottom: 2px;border-bottom: 1px solid #333;"><strong>Text: </strong>',i+=n,i+='</li><li style="padding-top: 2px; padding-bottom: 2px;border-bottom: 1px solid #333;width: 100%; overflow: hidden;text-overflow: ellipsis; white-space: nowrap;"><strong>Href: </strong>',i+=e.href,i+="</li><li>",i+='<ul style="padding: 0; margin: 0; list-style: none;">',o.params.length>0&&o.params.forEach((e=>{i+='<li style="padding: 2px 0 2px 20px; border-bottom: 1px solid #333;"><strong>',i+=e.key,i+=":</strong> ",i+=e.value,i+="</li> "})),o.attrs.length>0&&o.attrs.forEach((e=>{i+='<li style="padding-top: 2px; padding-bottom: 2px;border-bottom: 1px solid #333;"><strong>',i+=e.key,i+=":</strong> ",i+=e.value,i+="</li> "})),i+="</ul></li></ul>",t.innerHTML=i,t.style.position="absolute",t.style.backgroundColor="rgba(0, 169, 224, 0.9)",t.style.padding="12px",t.style.zIndex="9999",t.style.fontSize="10px",t.style.textAlign="left",t.style.whiteSpace="nowrap",t.style.textOverflow="ellipsis",t.style.overflow="hidden",t.style.width="400px",t.style.height="auto",t.style.borderRadius="5px",t.style.top="30px",t.style.left="30px",t.style.color="#333",t.style.boxShadow="0 2px 8px rgba(0, 0, 0, 0.15)",t.style.fontFamily="Arial, sans-serif",t.style.textTransform="none",t.style.transition="all 0.3s ease",t.classList.add("link-overlay"),e.appendChild(t),t.onclick=e=>{e.stopPropagation(),e.preventDefault(),t.style.zIndex=l++}}))}();`;
  return (
    <div className="max-w-6xl mb-4 font-sans text-slate-900 flex flex-col lg:flex-row gap-8">
      {/* LEFT SIDE: THE FORM (Flex-1) */}
      <div className="flex-1">
        <p>
          Displays URL data overlays (data includes: text/image alt text, href,
          attributes, and URL parameters) on any webpage.
        </p>
        <h3 className="mt-6">How to install (Chrome browser)</h3>
        <ul>
          <ol className="list-decimal list-inside">
            <li>Right-click your Bookmarks Bar and select Add Page</li>
            <li>Give the bookmark a name like "URL Data Overlay"</li>
            <li>
              Copy and paste the code below into the URL field.
              <br />
              <div className="bg-gray-100 p-2 rounded my-2 pt-10 group relative">
                <button
                  onClick={() => copy(bookmarkletCode)}
                  className="absolute top-2 right-2 text-slate-900 px-2 py-1 text-xs bg-blue-400 rounded opacity-80 group-hover:opacity-100 transition-opacity"
                >
                  {copied ? "Copied!" : "Copy to clipboard"}
                </button>
                <pre className="text-xs overflow-x-auto max-h-40 overflow-y-scroll">
                  <code
                    style={{ wordBreak: "break-all", whiteSpace: "pre-wrap" }}
                  >
                    {bookmarkletCode}
                  </code>
                </pre>
              </div>
            </li>
            <li>Click "Save"</li>
          </ol>
        </ul>
        <h3>How to use this Bookmarklet</h3>
        <ul className="list-disc list-inside">
          <li>
            Click your new bookmarklet on any webpage to see URL data overlays.
          </li>
          <li>Click an overlay to bring it to the front.</li>
          <li>Click the bookmarklet again to remove the overlays.</li>
        </ul>

        <h3>Screenshot of Bookmarklet Overlay</h3>
        <img
          src={screenshot}
          alt="Bookmarklet Demo"
          className="rounded shadow"
        />
      </div>

      {/* RIGHT SIDE: LIVE STATISTICS (W-80) */}
      <div className="lg:w-80 space-y-4"></div>
    </div>
  );
}
